
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/react-charts/content-security-policy",
      function () {
        return require("private-next-pages/x/react-charts/content-security-policy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/react-charts/content-security-policy"])
      });
    }
  